module.exports = __webpack_public_path__ + "static/media/page-not-found.44269f11.svg";